import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1;

  iframe {
    border: none;
    height: 100%;
    width: 100%;
  }
`
